<template>
<nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom">
    <div class="container-fluid">
      <span class="navbar-brand">{{ nomeempresa }}</span>
    </div>
    <span style="float: right; padding-right: 20px;" @click.prevent="mtdlogoff()">
      <i style="font-size: 18px; cursor: pointer;" class="bi bi-box-arrow-right"></i>
    </span>
  </nav>
</template>
<script>
// @ is an alias to /src

import util from '@/util';


export default {
  name: 'mcabecalho',

  data(){
    return{
      nomeempresa : ''
    }
  },

  methods: {
    mtdlogoff(){
      util.logoff();
    }
  },
  mounted() {
    

  },
  computed:{
    nomeempresa(){
      return this.$store.state.usuario.descfilialpadrao
    }
    
  }
}
</script>
